export default {
  AlterarFotoPerfil: axios.create({
    baseURL: process.env.VUE_APP_ENDPOINT_API + "alterar-foto-perfil"
  })
}


//////////////////
// WEBPACK FOOTER
// ../core/resources/routes/AlterarFotoPerfil.js
// module id = 4vn8
// module chunks = 13